import React from 'react';
import { FileText } from 'lucide-react';
import './CardNavigation.css';

interface CardNavigationProps {
    totalCards: number;
    currentCard: number;
    onCardClick: (index: number) => void;
}

export const CardNavigation: React.FC<CardNavigationProps> = ({
    totalCards,
    currentCard,
    onCardClick
}) => {
    return (
        <div className="crnv-container">
            <div className="crnv-header">
                <FileText size={16} />
                <span className="crnv-label">Cards ({totalCards})</span>
            </div>
            <div className="crnv-dots">
                {Array.from({ length: totalCards }, (_, index) => (
                    <button
                        key={index}
                        className={`crnv-dot ${index === currentCard ? 'crnv-dot--active' : ''}`}
                        onClick={() => onCardClick(index)}
                        title={`Card ${index + 1}`}
                    >
                        {index + 1}
                    </button>
                ))}
            </div>
        </div>
    );
};